const global = window

// Remplissage automatique
inputs.behavior.focus = function (data, name, niceName, type, input, parent, inputWindow) {
    if (data.focus) {
        input.focus();
    }
    return data
}
